
import { Button as UIButton } from "@/components/ui/button";
import { ReactNode } from "react";

interface ButtonProps {
  variant?: "default" | "outline";
  size?: "sm" | "default";
  children: ReactNode;
}

const Button = ({ variant = "default", size = "default", children }: ButtonProps) => {
  return (
    <UIButton variant={variant} size={size}>
      {children}
    </UIButton>
  );
};

export default Button;
